'use strict';

export default class BaseComponent {
	constructor () {

	}


	/**
	 *
	 * Function to parse array or object args
	 *
	 * @param _default {Object<*>|Array<*>|string}
	 * @param _args {Object<*>|Array<*>|string}
	 * @return {Object<*>|Array<*>|string}
	 *
	 */
	parseArgs(_default, _args) {
		if (Array.isArray(_args) && Array.isArray(_default)) {
			let parsedArgs = [];
			for (let i = 0; i < _default.length; i++) {
				parsedArgs.push(this.parseArgs(_default[i], _args[i]));
			}
			return parsedArgs;
		} else if (_args instanceof Object && typeof _args === 'object' && _default instanceof Object && typeof _default === 'object') {
			let mergedArgs = {};
			for (let key in _default) {
				mergedArgs[key] = key in _args ? this.parseArgs(_default[key], _args[key]) : _default[key];
			}
			for (let key in _args) {
				if (!(key in _default)) {
					mergedArgs[key] = _args[key];
				}
			}
			return mergedArgs;
		} else {
			if (!_args) {
				return _default;
			}

			return _args;
		}
	}
}
